import React from 'react'

import { ListingStatus } from 'bpm/pages/ProductsPage/ProductDetailsPage/components/ListingHeaderVariants/ListingStatusVariant'
import { processEnv } from 'components/configuration/environmentVariables'
import MoreFilterCategoryCheckbox from './MoreFilterCategoryCheckbox'
import MoreFilterDateRange from './MoreFilterDateRange'

export interface MoreFilterSubCategoriesProps {
    showDeltekWriterDraftFilter: boolean
    showSwatchboxFilter?: boolean
    value: number
    filterDisabledValues?: Record<string, string[]>
    isDeltekUser?: boolean
}
export enum PartnershipsOption {
    BIMsmith = 'BIMsmith',
    Swatchbox = 'Swatchbox',
    ULE = 'ULE',
    SustainableMinds = 'Sustainable Minds',
}

export enum StatusOption {
    true = 'Active',
    false = 'Inactive',
}

export enum DeltekWriterDraftOption {
    true = 'DeltekWriterDraft',
}

const statesOption = Object.values(ListingStatus).map((listingStatus) => {
    return { name: listingStatus, value: listingStatus }
})

export enum AdditionalContentOption {
    hasBimLinks = 'BIM Content',
    hasCatalogs = 'Product Catalog',
    hasDocumentFL = 'Full Length',
    hasDocumentSF = 'Short Form',
}

const MoreFilterSubCategories: React.FC<MoreFilterSubCategoriesProps> = ({
    showDeltekWriterDraftFilter,
    showSwatchboxFilter = !!Number(processEnv.REACT_APP_ShowSwatchbox),
    value,
    filterDisabledValues,
    isDeltekUser,
}) => {
    let renderData = <></>
    const statesOptionFiltered = JSON.parse(JSON.stringify(statesOption))
    if (!isDeltekUser) {
        statesOptionFiltered.splice(statesOptionFiltered.length - 1, 1)
    }
    switch (value) {
        case 1:
            let partnershipsOption = Object.values(PartnershipsOption).map(
                (partnerships: string) => ({
                    name: partnerships,
                    value: partnerships,
                })
            )

            if (!showSwatchboxFilter)
                partnershipsOption = partnershipsOption.filter(
                    (p) => p.name !== PartnershipsOption.Swatchbox
                )

            renderData = (
                <MoreFilterCategoryCheckbox
                    optionList={partnershipsOption}
                    filterCategoryName={'partnerships'}
                    disabledValues={filterDisabledValues?.partnerships ?? []}
                />
            )
            break
        case 2:
            const additionalContentOption = Object.keys(
                AdditionalContentOption
            ).map((additionalContent: string, ind: number) => ({
                name: Object.values(AdditionalContentOption)[ind],
                value: additionalContent,
            }))
            renderData = (
                <MoreFilterCategoryCheckbox
                    optionList={additionalContentOption}
                    filterCategoryName={'additionalContent'}
                    disabledValues={
                        filterDisabledValues?.additionalContent ?? []
                    }
                />
            )
            break
        case 3:
            renderData = <MoreFilterDateRange />
            break
        case 4:
            renderData = (
                <MoreFilterCategoryCheckbox
                    optionList={statesOptionFiltered}
                    filterCategoryName={'submissionStatus'}
                    disabledValues={
                        filterDisabledValues?.submissionStatus ?? []
                    }
                />
            )
            break
        case 5:
            const statusOption = Object.keys(StatusOption).map(
                (status: string, ind: number) => ({
                    name: Object.values(StatusOption)[ind],
                    value: status,
                })
            )
            const draftOption = Object.keys(DeltekWriterDraftOption).map(
                (status: string, ind: number) => ({
                    name: Object.values(DeltekWriterDraftOption)[ind],
                    value: status,
                })
            )
            renderData = (
                <>
                    <MoreFilterCategoryCheckbox
                        optionList={statusOption}
                        filterCategoryName={'isActive'}
                        disabledValues={filterDisabledValues?.status ?? []}
                    />
                    {showDeltekWriterDraftFilter && (
                        <MoreFilterCategoryCheckbox
                            optionList={draftOption}
                            filterCategoryName={'isDeltekWriterDraft'}
                            disabledValues={
                                filterDisabledValues?.deltekWriterDraft ?? []
                            }
                        />
                    )}
                </>
            )
            break
        default:
            renderData = <></>
    }
    return renderData
}

export default MoreFilterSubCategories
